

<template>
<div class="container">
	<div class="row">
		<div class="col-12 mb-5">
			<h3>{{metadata.title}}</h3>
			<small class="mutted" v-for="location in metadata.locations" :key="location.id">
				<div>	{{location}} </div>
			</small>
		</div>
	</div>
	<div class="row">
		<div class="col-12 mb-5">
			<h4>Descripton</h4>
			<p>
			The PHP Developerr will support existing systems and work on a wide range of development projects. We are looking for people who are passionate and with diverse backgrounds and experience.
			</p>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-6">
			<h4>Requirements</h4>
			<p>
				<ul>
					<li>
						Experience with PHP and HTML
					</li>
					<li>
						Experience with popular frameworks and platforms such as Laravel, Symfony, Drupal, Wordpress etc
					</li>
					<li>
						Knowledge of GIT and Bitbucket systems
					</li>
					<li>
						Understangin Agile development principles such as Sprints, Continious Deployment, Testing etc.
					</li>
					<li>
						A strong understanding of object-oriented programming and MVC model.
					</li>
					<li>
						Experience with SQL and NoSql databases
					</li>
					<li>
						Ability to troubleshoute and analyze legacy applications
					</li>
					<li>
						Good communication skills
					</li>
				</ul>
			</p>
		</div>
		<div class="col-sm-6">
			<h4>Responsibilities</h4>
			<p>
				<ul>
					<li>
						Build applications according to the design and provide designers with feedback and suggest trade-offs when required
					</li>
					<li>
						Work closely with frontend developers 
					</li>
					<li>
						Ensure the code follows latest coding practices and industry standards
					</li>
					<li>
						Write both unit and integration tests, and develop automation tools for daily tasks
					</li>
					<li>
						Challenge ideas and opinions to avoid pitfalls and inefficient solutions
					</li>
				</ul>
			</p>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<div class="card my-5">
				<div class="card-body bg-white text-dark">
					<h1 class="card-title text-dark">Applay for this job</h1>
					<p class="card-text">
						Please fill in the pre-selection application form. It will help us to provide you with the most relevant information and onboarding procedures.
					</p>
					<hire-form :metadata="metadata"></hire-form>
				</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
import HireForm from "./../components/HireForm";
export default {
	components: {
		HireForm,
	},
	data() {
		return {
			metadata: {
				section: "vacancy",
				title: "PHP Developer",
				locations: ["London (UK)", "Cambridge (UK)"]
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
